import * as React from "react";
const SvgFiRrCloudDisabled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-disabled_svg__a)">
      <path
        fill="#062147"
        d="M21.781 20.367a7.5 7.5 0 0 0 2.2-4.729 7.96 7.96 0 0 0-5.62-8.277 1.09 1.09 0 0 1-.722-.734A7.96 7.96 0 0 0 4.57 3.154L1.707.294A1 1 0 0 0 .293 1.706l22 22a1 1 0 0 0 1.414-1.414zM9.101 3.065a5.99 5.99 0 0 1 6.623 4.155 3.1 3.1 0 0 0 2.044 2.052 5.97 5.97 0 0 1 4.213 6.21 5.4 5.4 0 0 1-1.627 3.458L5.982 4.568A5.95 5.95 0 0 1 9.1 3.065m7.892 18.763a1 1 0 0 1-.887 1.1q-.66.071-1.32.07h-9.1A5.84 5.84 0 0 1 .056 18.3a5.45 5.45 0 0 1 2.881-5.65 7.65 7.65 0 0 1-.858-4.789 1 1 0 0 1 1.981.278 5.97 5.97 0 0 0 .6 3.585 2 2 0 0 1-.79 2.7 3.47 3.47 0 0 0-1.833 3.6A3.81 3.81 0 0 0 5.683 21h9.1q.556 0 1.107-.059a1.01 1.01 0 0 1 1.103.887"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-disabled_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudDisabled;
